export default __webpack_public_path__ + "static/media/03-shirt-trimmed-flipped.2a57a3c2.png";